// StartFromShapeEntryButton — Phase 5 Migration B sub-track (c) UI seed.
//
// Secondary entry-point button mounted above the customer picker on the new-
// invoice authoring panel. Per Q7 lock, primary path remains customer-picker-
// first; this is the SECONDARY route into authoring. Phase 6 Wave 6 folds the
// pattern into the cb.RouterSheet grammar.

import { ChevronRight, Layers } from 'lucide-react';
import { palette, radii, spacing } from '../../styles/tokens';

interface Props {
  onClick: () => void;
}

export function StartFromShapeEntryButton({ onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: spacing.sm,
        padding: spacing.md, marginBottom: spacing.md,
        background: palette.white, border: `1px solid ${palette.g200}`,
        borderRadius: radii.md, cursor: 'pointer', textAlign: 'left',
        fontFamily: 'inherit',
      }}
    >
      <div style={{
        width: 36, height: 36, borderRadius: 10,
        background: palette.blueWash,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Layers size={18} color={palette.blue} strokeWidth={1.8} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: palette.g800 }}>
          Start from a saved shape
        </div>
        <div style={{ fontSize: 12, color: palette.g500, marginTop: 2 }}>
          Use the line items + terms from one of your saved shapes.
        </div>
      </div>
      <ChevronRight size={16} color={palette.g400} strokeWidth={2} />
    </button>
  );
}
